import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const rmaOverview = css`
  .rma-overview {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }

  csc-table {
    --cse-badge-display: grid;
  }

  .rma-overview__card {
    --cse-badge-display: grid;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};

    .rma-overview__card-info {
      display: flex;
      flex-direction: column;
      gap: ${csSpacing.spacing04};
    }

    .rma-overview__card-meta {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: ${csSpacing.spacing05};
    }

    .rma-overview__card-user {
      display: flex;
      flex-direction: column;
      gap: ${csSpacing.spacing02};
    }
  }

  .rma-overview__list {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }
`
